export const GET_SPORTS_RECORDS = 'GET_SPORTS_RECORDS'
export const GET_SPORTS_RECORD = 'GET_SPORTS_RECORD'
export const CREATE_SPORTS_RECORD = 'CREATE_SPORTS_RECORD'
export const UPDATE_SPORTS_RECORD = 'UPDATE_SPORTS_RECORD'
export const DELETE_SPORTS_RECORD = 'DELETE_SPORTS_RECORD'
export const GET_SPORT_STUDENTS = 'GET_SPORT_STUDENTS'
export const ADD_STUDENTS_TO_SPORT = 'ADD_STUDENTS_TO_SPORT'
export const REMOVE_STUDENT_FROM_SPORT = 'REMOVE_STUDENT_FROM_SPORT'
export const GET_AVAILABLE_STUDENTS = 'GET_AVAILABLE_STUDENTS'
export const REMOVE_MANY_SPORTS_STUDENTS = 'REMOVE_MANY_SPORTS_STUDENTS'
export const DELETE_MANY_SPORTS_RECORDS = 'DELETE_MANY_SPORTS_RECORDS'
